import { LazyQueryHookOptions, gql } from "@apollo/client"
import { Money, MoneyInput } from "@oysterhr/schema"
import { useLazyPublicCostCalculatorQuery } from "./usePublicCostCalculatorQuery"

const TotalHiringQuery = gql`
  query TotalMultipleCurrencies($currencies: [MoneyInput!]!, $currencyCode: String!) {
    totalMultipleCurrencies(currencies: $currencies, currencyCode: $currencyCode) {
      subunit
      currencyCode
      __typename
    }
  }
`

export const useTotalHiringCost = (
  options?: LazyQueryHookOptions<
    { totalMultipleCurrencies: Money },
    { currencyCode: string; currencies: MoneyInput[] }
  >,
) => {
  return useLazyPublicCostCalculatorQuery(TotalHiringQuery, options)
}
